<template>
    <el-container>
        <div v-if="!hasKeyword">
            <SideMenu />
        </div>
        <el-container direction="vertical">
            <div v-if="!hasKeyword">
                <TopHeader />
            </div>
            <el-main>
                <router-view />
            </el-main>
        </el-container>
    </el-container>
</template>


<script setup>
// import 'element-plus/lib/theme-chalk/index.css';
import { Button } from 'element-plus';
import TopHeader from '@/components/mainbox/TopHeader.vue';
import SideMenu from '@/components/mainbox/SideMenu.vue';
const str = window.location.href;
const hasKeyword = str.includes("/news-manage/addnews/");
// console.log(hasKeyword); // true
</script>

<style lang="scss" scoped>
.el-main {
    overflow: auto;
    height: calc(100vh - 60px);
}
</style>